import React from 'react';
import { Col } from 'reactstrap';
import PropTypes from 'prop-types';
import { Skeleton } from '@mui/material';
import CO2Icon from './CO2Icon';
import './styles.scss';

const formatNumber = (value) => {
  const num = Number(value);
  return Number.isNaN(num) ? value : num.toLocaleString('en-US');
};

/*=============================================
=            Card Totals Conponent            =
=============================================*/
function CardTotals(props) {
  const { accentColor, co2, showCo2 } = props;

  return (
    <Col xl={props.xl} md={props.md} sm={props.sm}>
      <div className="co2-card shadow">
        {props.loading ? (
          <>
            <Skeleton variant="rectangular" height={140} width="35%" />
            <Skeleton height={140} width="65%" className="margin_left" />
          </>
        ) : (
          <>
            <div className="co2-card-icon" style={{ backgroundColor: accentColor }}>
              {props.image}
            </div>
            <div className="co2-card-info">
              <div className="co2-card-title" style={{ color: accentColor }}>
                {props.title}
                <span className="co2-card-title-underline" style={{ backgroundColor: accentColor }} />
              </div>
              <div className="co2-card-total" style={{ color: accentColor }}>{formatNumber(props.total)}</div>
              <div className="co2-card-divider" />
              <div
                className="co2-card-footer"
                style={showCo2 ? { backgroundColor: `${accentColor}1A` } : undefined}
              >
                {showCo2 ? (
                  <>
                    <div className="co2-badge">
                      <CO2Icon color={accentColor} size={30} />
                    </div>
                    <div className="co2-footer-separator" style={{ backgroundColor: accentColor }} />
                    <div className="co2-value" style={{ color: accentColor }}>
                      <span className="co2-value-number">{formatNumber(co2)}</span>
                      <span className="co2-value-unit">kg CO<sub>2</sub></span>
                    </div>
                  </>
                ) : null}
              </div>
            </div>
          </>
        )}
      </div>
    </Col>
  );
}

CardTotals.defaultProps = {
  xl: 3,
  md: 6,
  sm: 12,
  accentColor: '#0060a8',
  co2: 0,
  showCo2: true,
};

CardTotals.propTypes = {
  xl: PropTypes.number,
  md: PropTypes.number,
  sm: PropTypes.number,
  image: PropTypes.element,
  total: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  title: PropTypes.string,
  accentColor: PropTypes.string,
  co2: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  showCo2: PropTypes.bool,
};

export default CardTotals;
